import { useEffect, useState, useMemo } from 'react';
import { Card, Space, Table, Input, Button, Flex, Select, Divider, Row, Col, Statistic } from 'antd';
import CustomerService from "services/customer"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
import { useNavigate } from 'react-router';
import CustomerInfoModal from "components/customer/InfoModal"
import _ from "lodash"
const service = new CustomerService();
const { Search } = Input;
const OrderList = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [filter, setFilter] = useState({ info: "" })
    const [clickPhone, setClickPhone] = useState("");
    const [showCustomerInfo, setShowCustomerInfo] = useState(false);

    // useEffect(() => {
    //     loadData({});
    // }, [])

    useEffect(() => {
        delaySearch(filter);
    }, [filter])

    const loadData = async (data) => {
        var lst = await service.list(data);
        setData(lst);
    }

    const delaySearch = useMemo(() => _.debounce(loadData, 500), []);

    const onSearch = () => {
        delaySearch({});
    }

    const setFilterValue = (name, value) => {

        var newFilter = { ...filter };
        newFilter[name] = value;
        setFilter(newFilter)
    }
    const updateStats = async (id) => {
        await service.updateStats(id);
        loadData();
    }

    const showCustomer = phone => {
        setClickPhone(phone);
        setShowCustomerInfo(true);
    }


    const columns = [
        {
            title: 'Khách hàng',
            render: (record) => {

                return (

                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Button type='text' onClick={e => showCustomer(record.phone)} >
                                {record.phone}
                            </Button>
                        </Col>
                        <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                                {record.full_name}
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                Doanh  số:  {formatCurrency(record.stats?.total_spend)}
                            </div>
                        </Col>
                        <Col span={12}>
                            <div style={{ textAlign: "right" }}>
                                Xu:  {formatCurrency(record.loyalty_point?.current)}
                            </div>
                        </Col>
                        <Col span={24}>

                            <div>

                                {record.stats?.last_order?.id &&
                                    <Row gutter={[8, 8]}>
                                        <Col span={8}>
                                            <div>{record.stats?.last_order?.id}</div>
                                        </Col>
                                        <Col span={8}>
                                            <div>
                                                {formatCurrency(record.stats?.last_order.total_amount)}
                                            </div>
                                        </Col>
                                        <Col span={8}>
                                            <div>
                                                {formatDate(record.stats?.last_order.create_on)}
                                            </div>
                                        </Col>





                                    </Row>
                                }
                            </div>
                        </Col>
                        <Col span={12}></Col>

                    </Row>

                )

            }
        },








    ];

    return (
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <Card style={{ width: "100%" }}>
                <Space direction='vertical' style={{ width: "100%" }}>


                    <Search
                        placeholder="Số điện thoại hoặc tên"
                        onSearch={onSearch}
                        onChange={e => setFilterValue("info", e.target.value)}
                        style={{
                            width: "100%",
                        }}
                    />

                </Space>
                <Divider></Divider>
                <Row gutter={16}>
                    <Col span={12}>
                        <Statistic title="Tổng   khách hàng" value={data.length} />
                    </Col>
                    <Col span={12}>
                        <Statistic title="Tổng   xu" value={_.sumBy(data, x => x.loyalty_point?.current ?? 0)} precision={0} />

                    </Col>

                </Row>
            </Card>
            <Card style={{ width: "100%" }}>
                <Table dataSource={data} columns={columns} showHeader={false} />
            </Card>
            <CustomerInfoModal phone={clickPhone} open={showCustomerInfo} onClose={e => setShowCustomerInfo(false)}></CustomerInfoModal>
        </Space>
    )
}

export default OrderList;
